/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

export type ValidationType =
	'NOT_BLANK' |
	'NOT_EMPTY' |
	'NOT_NULL' |
	'LENGTH' |
	'RANGE' |
	'MIN' |
	'MAX' |
	'ZIP_CODE_MATCHING_COUNTRY' |
	'HOUSE_NUMBER_MATCHING_COUNTRY' |
	'UNKNOWN' |
	'DIGITS' |
	'EMAIL' |
	'URL';

export interface ConstraintViolationDTO {
	maxLength?: number;
	maxValue?: number;
	minLength?: number;
	minValue?: number;
	maxFractionalDigits?: number;
	maxIntegralDigits?: number;
	propertyPath?: string;
	message?: string;
	validationType?: ValidationType;
}

export const violationsWithErrorMessages = (violations: ConstraintViolationDTO[]): { [key: string]: ConstraintViolationDTO[] } => {
	const messages: { [key: string]: ConstraintViolationDTO[] } = {};

	violations.forEach((violation: ConstraintViolationDTO) => {
		const propertyPath: string = violation.propertyPath ? violation.propertyPath : 'unknown';

		messages[propertyPath] = messages[propertyPath] || [];
		messages[propertyPath].push(violationWithErrorMessage(violation));
	});

	return messages;
};

const violationWithErrorMessage = (violation: ConstraintViolationDTO): ConstraintViolationDTO => {
	let message;

	switch (violation.validationType) {
		case 'NOT_BLANK':
		case 'NOT_EMPTY':
		case 'NOT_NULL':
			message = 'Verplicht in te vullen';
			break;
		case 'EMAIL':
			message = 'Vul een geldig e-mailadres in';
			break;
		case 'LENGTH':
			if (violation.minLength === 0)
				message = 'Voer maximaal ' + violation.maxLength + ' tekens in';
			else
				message = 'Voer minimaal ' + violation.minLength + ' tekens in, en maximaal ' + violation.maxLength;
			break;
		case 'RANGE':
			message = 'Invoer moet minimaal gelijk zijn aan ' + violation.minValue + ', en maximaal gelijk aan ' + violation.maxValue;
			break;
		case 'MIN':
			message = 'Invoer moet minimaal gelijk zijn aan ' + violation.minValue;
			break;
		case 'MAX':
			message = 'Invoer mag maximaal gelijk zijn aan ' + violation.maxValue;
			break;
		case 'DIGITS':
			if (violation.maxFractionalDigits === 0)
				message = 'Vul een geheel getal in van maximaal ' + violation.maxIntegralDigits + ' cijfers';
			else
				message = 'Vul een getal in met maximaal ' + violation.maxIntegralDigits +
					' cijfers' + ((violation.maxIntegralDigits || 0) > 1 ? 's' : '') + ' vóór de komma, en maximaal ' +
					violation.maxFractionalDigits + ' na de komma.';
			break;
		case 'ZIP_CODE_MATCHING_COUNTRY':
			message = 'Postcode komt niet overeen met land';
			break;
		case 'HOUSE_NUMBER_MATCHING_COUNTRY':
			message = 'Huisnummer komt niet overeen met land';
			break;
		case 'URL':
		case 'UNKNOWN':
		default:
			message = 'Ongeldige invoer';
	}

	return {...violation, message};
};
